// TODO: [SUBSCRIPTIONS
// import {
//   ApolloClient,
//   InMemoryCache,
//   ApolloLink,
//   split,
// } from '@apollo/client';
// import { WebSocketLink } from '@apollo/client/link/ws';
// import { onError } from '@apollo/client/link/error';
// import { createUploadLink } from 'apollo-upload-client';
// import { getMainDefinition } from '@apollo/client/utilities';

// const cache = new InMemoryCache();

// // 🔐 Auth middleware
// const authLink = new ApolloLink((operation, forward) => {
//   const token = localStorage.getItem('token');
//   operation.setContext({
//     headers: {
//       authorization: token ? `Bearer ${token}` : '',
//     },
//   });
//   return forward(operation);
// });

// // 🔌 WebSocket link (for subscriptions only)
// const wsLink = new WebSocketLink({
//   uri: 'ws://localhost:4000/subscriptions',
//   options: {
//     reconnect: true,
//     lazy: true,
//     connectionParams: () => {
//       const token = localStorage.getItem('token');
//       return {
//         authorization: token ? `Bearer ${token}` : '',
//       };
//     },
//   },
// });

// // 🧠 HTTP link (for queries and mutations)
// const httpLink = authLink.concat(
//   createUploadLink({
//     uri: (window as any)._env_.REACT_APP_GRAPHQL_URL,
//   })
// );

// // 🧠 Error handler
// const errorLink = onError(({ graphQLErrors, networkError }) => {
//   if (graphQLErrors) {
//     graphQLErrors.forEach(({ message, locations, path }) => {
//       if (message === 'Not Authorised!') {
//         localStorage.removeItem('token');
//         window.location.replace('/logout');
//       }
//       try {
//         console.log(
//           `[GraphQL error]: Message: ${message}, Location: ${JSON.stringify(
//             locations
//           )}, Path: ${path}`
//         );
//       } catch (error) {
//         console.log(
//           `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
//         );
//       }
//     });
//   }

//   if (networkError) console.log(`[Network error]: ${networkError}`);
// });

// // 🔀 Split traffic: subscriptions → wsLink, everything else → httpLink
// const splitLink = split(
//   ({ query }) => {
//     const definition = getMainDefinition(query);
//     return (
//       definition.kind === 'OperationDefinition' &&
//       definition.operation === 'subscription'
//     );
//   },
//   // TODO: [SUBSCRIPTIONS
//   // wsLink,
//   httpLink
// );

// // 🚀 Final Apollo Client
// const client = new ApolloClient({
//   link: ApolloLink.from([errorLink, splitLink]),
//   cache,
// });

// export default client;

//// TODO: [SUBSCRIPTIONS: Delete following:

import { ApolloLink, ApolloClient, InMemoryCache } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { createUploadLink } from 'apollo-upload-client';

const cache = new InMemoryCache();

const authLink = new ApolloLink((operation, forward) => {
  const token = localStorage.getItem('token');
  const initialToken = localStorage.getItem('initialToken');
  let imp = {};
  if (initialToken) {
    imp = {
      imp: initialToken,
    };
  }
  operation.setContext({
    headers: {
      authorization: token ? `Bearer ${token}` : '',
      ...imp
    },
  });

  return forward(operation);
});

// const afterwareLink = new ApolloLink((operation, forward) => {
//   return forward(operation).map((response) => {
//     const context = operation.getContext()
//     const xVers = context.response.headers.get('x-vers')
//     const itms = JSON.parse(xVers)

//     if(itms && itms.hc) {
//       const hcVersion = parseInt(itms.hc)
//     }
//     console.log({xVers: authHeader})
//     return response
//   })
// })

const link = ApolloLink.from([
  onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      graphQLErrors.forEach(({ message, locations, path }) => {
        if (message === 'Not Authorised!') {
          localStorage.removeItem('token');
          window.location.replace('/logout');
        }
        try {
          console.log(`[GraphQL error]: Message: ${message}, Location: ${JSON.stringify(locations)}, Path: ${path}`);
        } catch (error) {
          console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`);
        }
      });
    }

    if (networkError) console.log(`[Network error]: ${networkError}`);
  }),
  authLink,
  // afterwareLink,
  createUploadLink({ uri: (window as any)._env_.REACT_APP_GRAPHQL_URL }),
]);

const client = new ApolloClient({
  link,
  cache,
});

export default client;
